import PropTypes from 'prop-types';
import React from 'react';
import { accessRoles } from  '../../../data/appConstants';

const RoleSpecificProfile = ({
  user,
  userDetails,
  roleSpecificContent,
  userEmailId
}) => {
  const { firstName = '', lastName = '' } = userDetails || {};
  const role = user?.roles?.[0];
  return (
      <div className='bg-grey-profile'>
        <div className='profile-styling'>
          <div className='user-heading -size-xl text'>
            {`${firstName} ${lastName}`}
            {
              <div className='approved-status-container'>
                <i className='a-icon boschicon-bosch-ic-alert-success-filled status-checked'></i>
              </div>
            }
          </div>
          <div className='mail-text item sales-rep-margin'>
            <h5>{roleSpecificContent.mail_id} :</h5>
            <p className='label-text -size-l'>{userEmailId}</p>
          </div>
          <div className='number-text item sales-rep-margin'>
            <h5>{roleSpecificContent.role} :</h5>
            <p className='label-text -size-l'>
              {role === accessRoles.sales_rep && roleSpecificContent.sales_rep}
              {role === accessRoles.csm && roleSpecificContent.csm}
              {role === accessRoles.usp_admin && roleSpecificContent.usp_admin}
            </p>
          </div>
        </div>
      </div>
  );
};

RoleSpecificProfile.propTypes = {
  user: PropTypes.object,
  userDetails: PropTypes.object,
  roleSpecificContent: PropTypes.object,
  userEmailId: PropTypes.string
};

export default RoleSpecificProfile;
